import { logError } from '@/util/logger';
import { useErrorLoggerStore } from '@common/react/errorLogger';
import { useEffect } from 'react';

export const ErrorLoggerProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const setLogError = useErrorLoggerStore((state) => state.setLogError);

    useEffect(() => {
        setLogError(logError);
    }, [setLogError]);

    return <>{children}</>;
};
